export const addBrazilPhonePrefix = (phone?: string | null) => {
  if (!phone) {
    return null;
  }

  return !phone.startsWith("+55") ? "+55" + phone : phone;
};
